import { View, Text, StyleSheet } from "react-native";
import InputText from "./InputText";
import { Button, useTheme } from "react-native-paper";
import { useForm, Controller } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import sendEmailSchema from "../schemas/sendEmailSchema";
import { useState } from "react";
import useApi from "../hooks/useAPI";
import { showMessage } from "react-native-flash-message";

type inputData = {
	email: string;
};

type Props = {
	setEmail: (active: string) => void;
	emailSended: boolean;
	setEmailSended: (active: boolean) => void;
};

const SendEmail = ({ setEmail, emailSended, setEmailSended }: Props) => {
	const { colors } = useTheme();
	const api = useApi();
	const [loading, setLoading] = useState(false);

	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<inputData>({
		resolver: joiResolver(sendEmailSchema),
	});

	const onSubmit = async (data: inputData) => {
		setLoading(true);
		try {
			await api.redefinePassword.verifyEmail(data.email);
			showMessage({
				type: "success",
				message:
					"Verificação de e-mail bem-sucedida.\n" +
					`Verifique a caixa de entrada de: ${data.email}`,
			});
			setEmail(data.email);
			setEmailSended(true);
		} catch (e) {
			showMessage({ type: "danger", message: "Verificação de e-mail falhou." });
		} finally {
			setLoading(false);
		}
	};

	return (
		<View>
			<Text style={styles.header}>Redefinir senha</Text>
			<Text style={styles.text}>
				Insira seu nome de usuário ou e-mail e nós enviaremos um código de
				segurança para que você possa criar uma nova senha de acesso.
			</Text>
			<Controller
				control={control}
				rules={{
					required: true,
				}}
				render={({ field: { onChange, onBlur, value } }) => (
					<InputText
						placeholder="Digite seu e-mail"
						style={[
							styles.input,
							{
								borderColor: errors.email
									? colors.error
									: colors.inputBackgroundColor,
							},
						]}
						onBlur={onBlur}
						onChange={onChange}
						value={value}
						selectionColor={colors.primary}
						textColor={errors.email ? colors.error : colors.text}
						placeholderTextColor={errors.email ? colors.error : colors.text}
						disabled={emailSended || loading}
					/>
				)}
				name="email"
			/>
			<Button
				style={styles.btn}
				labelStyle={styles.btnText}
				mode="contained"
				onPress={handleSubmit(onSubmit)}
				disabled={emailSended || loading}
			>
				Enviar e-mail
			</Button>
		</View>
	);
};

export default SendEmail;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		backgroundColor: "#fff",
		paddingHorizontal: "5%",
		paddingTop: 16,
	},

	header: {
		fontWeight: "600",
		fontSize: 32,
	},
	input: {
		marginTop: 30,
		alignSelf: "center",
		width: "100%",
		zIndex: 0,
		borderWidth: 1,
	},
	btn: {
		marginTop: 10,
		borderRadius: 25,
		width: "100%",
		height: 50,

		alignSelf: "center",
	},
	btnText: {
		color: "#fff",
		fontSize: 15,
		lineHeight: 30,
		width: "90%",
	},
	text: {
		letterSpacing: 0.25,
		color: "#999999",
		lineHeight: 20,
		fontWeight: "400",
		fontSize: 15,
	},
	didntRecieveCode: {
		alignSelf: "flex-end",
	},
});
